import { useQuery } from "react-query";
import { Api } from "src/apis/helpers/configs/api";
import { container } from "tsyringe";
import { ProjectsService } from "src/apis/services/projects/projectsService";

export const useGetProjects = () => {
    const projectsService = container.resolve(ProjectsService);
    return useQuery({
        queryKey: [Api.Projects.getProjects],
        queryFn: () => {
            return projectsService.getProjects();
        }
    })
}
